var $3303b51f37a02711$exports = {};
$3303b51f37a02711$exports = {
    "rangeOverflow": (args)=>`El valor debe ser ${args.maxValue} o anterior.`,
    "rangeReversed": `La fecha de inicio debe ser anterior a la fecha de finalizaci\xf3n.`,
    "rangeUnderflow": (args)=>`El valor debe ser ${args.minValue} o posterior.`,
    "unavailableDate": `Fecha seleccionada no disponible.`
};


export {$3303b51f37a02711$exports as default};
//# sourceMappingURL=es-ES.mjs.map
